import ApiService from '../api.services';

const TaskScheduleService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/taskschedule');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/taskschedule/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        try {
            const data = {
                schedule: form
            }
            const res = await ApiService.post('/api/taskschedule', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            schedule: form
        }
        try {
            const response = await ApiService.put(`/api/taskschedule/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/taskschedule/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default TaskScheduleService;

export { TaskScheduleService };

